export default [
  // {
  //   path: '/:lang?/demo/swiper',
  //   name: 'demo-swiper',
  //   component: () => import('@/views/demo/Swiper.vue'),
  //   meta: { layout: 'default' },
  // },

  {
    path: '/:lang?/ui',
    component: () => import(
      /* webpackChunkName: "docs-layout" */
      '@/components/docs/Layout.vue'
    ),
    children: [
      {
        path: '',
        name: 'docs-introduction',
        component: () => import(
          /* webpackChunkName: "docs-introduction" */
          '@/views/docs/Index.vue'
        ),
      },
      {
        path: 'browsers',
        name: 'docs-browsers',
        component: () => import(
          /* webpackChunkName: "docs-browsers" */
          '@/views/docs/Browser.vue'
        ),
      },
      {
        path: 'layout',
        name: 'docs-layout',
        component: () => import(
          /* webpackChunkName: "docs-browsers" */
          '@/views/docs/Layout.vue'
        ),
      },
      {
        path: 'icons',
        name: 'docs-icons',
        component: () => import(
          /* webpackChunkName: "docs-icons" */
          '@/views/docs/Icons.vue'
        ),
      },
      {
        path: 'variables',
        name: 'docs-variables',
        component: () => import(
          /* webpackChunkName: "docs-variables" */
          '@/views/docs/Variables.vue'
        ),
      },
      {
        path: 'variables/colors',
        name: 'docs-color-variables',
        component: () => import(
          /* webpackChunkName: "docs-colors" */
          '@/views/docs/variables/ColorVariables.vue'
        ),
      },
      {
        path: 'variables/spacings',
        name: 'docs-spacing-variables',
        component: () => import(
          /* webpackChunkName: "docs-spacings" */
          '@/views/docs/variables/SpacingVariables.vue'
        ),
      },
      {
        path: 'variables/others',
        name: 'docs-other-variables',
        component: () => import(
          /* webpackChunkName: "docs-others" */
          '@/views/docs/variables/OtherVariables.vue'
        ),
      },
      {
        path: 'components',
        name: 'docs-components',
        component: () => import(
          /* webpackChunkName: "docs-components" */
          '@/views/docs/Components.vue'
        ),
      },
      {
        path: 'components/bootstrap',
        name: 'docs-component-bootstrap',
        component: () => import(
          /* webpackChunkName: "docs-components" */
          '@/views/docs/components/Bootstrap.vue'
        ),
      },
      {
        path: 'components/custom',
        name: 'docs-components-custom',
        component: () => import(
          /* webpackChunkName: "docs-components" */
          '@/views/docs/components/Custom.vue'
        ),
      },
      {
        path: 'utilities',
        name: 'docs-utility-classes',
        component: () => import(
          /* webpackChunkName: "docs-utility-classes" */
          '@/views/docs/UtilityClasses.vue'
        ),
      },
      {
        path: 'dark-mode',
        name: 'docs-dark-mode',
        component: () => import(
          /* webpackChunkName: "docs-dark-mode" */
          '@/views/docs/DarkMode.vue'
        ),
      },
      {
        path: 'resources',
        name: 'docs-resources',
        component: () => import(
          /* webpackChunkName: "docs-resources" */
          '@/views/docs/Resources.vue'
        ),
      },
      {
        path: 'tools/duotone-finder',
        name: 'docs-tool-duotone-finder',
        component: () => import(
          /* webpackChunkName: "docs-tool-duotone-finder" */
          '@/views/docs/tools/DuotoneFinder.vue'
        ),
      },



      // baseComponents on `/core/src/components/ui/`
      {
        path: 'components/core/BaseButtonLadda',
        name: 'docs-component-core-base-button-ladda',
        component: () => import(
          /* webpackChunkName: "docs-component-core-base-button-ladda" */
          '@/views/docs/components/core/ui/BaseButtonLadda.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseImg',
        name: 'docs-components-core-base-img',
        component: () => import(
          /* webpackChunkName: "docs-core-base-img" */
          '@/views/docs/components/core/ui/BaseImg.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseModalVuex',
        name: 'docs-component-core-modal-vuex',
        component: () => import(
          /* webpackChunkName: "docs-component-core-modal-vuex" */
          '@/views/docs/components/core/ui/BaseModalVuex.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseNotification',
        name: 'docs-component-core-base-notification',
        component: () => import(
          /* webpackChunkName: "docs-component-core-base-notification" */
          '@/views/docs/components/core/ui/BaseNotification.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BasePagination',
        name: 'docs-component-core-base-pagination',
        component: () => import(
          /* webpackChunkName: "docs-component-core-base-pagination" */
          '@/views/docs/components/core/ui/BasePagination.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BasePrice',
        name: 'docs-component-core-base-price',
        component: () => import(
          /* webpackChunkName: "docs-component-core-base-price" */
          '@/views/docs/components/core/ui/BasePrice.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseStepper',
        name: 'docs-component-core-base-stepper',
        component: () => import(
          /* webpackChunkName: "docs-component-core-base-stepper" */
          '@/views/docs/components/core/ui/BaseStepper.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseTimeSince',
        name: 'docs-component-core-base-timesince',
        component: () => import(
          /* webpackChunkName: "docs-component-core-base-timesince" */
          '@/views/docs/components/core/ui/BaseTimeSince.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/Blocker',
        name: 'docs-component-core-blocker',
        component: () => import(
          /* webpackChunkName: "docs-component-core-blocker" */
          '@/views/docs/components/core/ui/Blocker.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/LoaderSpin',
        name: 'docs-component-core-loader-spin',
        component: () => import(
          /* webpackChunkName: "docs-component-core-loader-spin" */
          '@/views/docs/components/core/ui/LoaderSpin.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/PageLoader',
        name: 'docs-component-core-page-loader',
        component: () => import(
          /* webpackChunkName: "docs-component-core-page-loader" */
          '@/views/docs/components/core/ui/PageLoader.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      // baseComponents on `/core/src/components/ui/`



      // baseComponents on `/core/src/components/*/`
      {
        path: 'components/core/AirtableForm',
        name: 'docs-component-core-airtable-form',
        component: () => import(
          /* webpackChunkName: "docs-component-core-airtable-form" */
          '@/views/docs/components/core/airtable/AirtableForm.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/ArtistAvatar',
        name: 'docs-component-core-artist-avatar',
        component: () => import(
          /* webpackChunkName: "docs-component-core-artist-avatar" */
          '@/views/docs/components/core/member/ArtistAvatar.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/FaqSection',
        name: 'docs-component-core-faq-section',
        component: () => import(
          /* webpackChunkName: "docs-component-core-faq-section" */
          '@/views/docs/components/core/modules/faqs/FaqSection.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseCarouselSwiper',
        name: 'docs-component-core-base-carousel-swiper',
        component: () => import(
          /* webpackChunkName: "docs-component-core-faq-section" */
          '@/views/docs/components/core/carousel/BaseCarouselSwiper.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      // baseComponents on `/core/src/components/`



      // baseComponents on `/core/src/components/ui/from`
      {
        path: 'components/core/BaseFilePicker',
        name: 'docs-components-core-base-file-picker',
        component: () => import(
          /* webpackChunkName: "docs-core-base-file-picker" */
          '@/views/docs/components/core/ui/form/BaseFilePicker.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseInputFile',
        name: 'docs-components-core-base-input-file',
        component: () => import(
          /* webpackChunkName: "docs-core-base-input-file" */
          '@/views/docs/components/core/ui/form/BaseInputFile.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseInputLabel',
        name: 'docs-components-core-base-input-label',
        component: () => import(
          /* webpackChunkName: "docs-core-base-input-label" */
          '@/views/docs/components/core/ui/form/BaseInputLabel.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      // {
      //   path: 'components/core/BaseInputNumber',
      //   name: 'docs-components-core-base-input-number',
      //   component: () => import(
      //     /* webpackChunkName: "docs-core-base-input-number" */
      //     '@/views/docs/components/core/ui/form/BaseInputNumber.vue'
      //   ),
      // },
      {
        path: 'components/core/BaseInputNumberSpinner',
        name: 'docs-components-core-base-input-number-spinner',
        component: () => import(
          /* webpackChunkName: "docs-core-base-input-number-spinner" */
          '@/views/docs/components/core/ui/form/BaseInputNumberSpinner.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseInputTag',
        name: 'docs-components-core-base-input-tag',
        component: () => import(
          /* webpackChunkName: "docs-core-base-input-tag" */
          '@/views/docs/components/core/ui/form/BaseInputTag.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseInputText',
        name: 'docs-components-core-base-input-text',
        component: () => import(
          /* webpackChunkName: "docs-core-base-input-text" */
          '@/views/docs/components/core/ui/form/BaseInputText.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseSelect',
        name: 'docs-components-core-base-select',
        component: () => import(
          /* webpackChunkName: "docs-core-base-select" */
          '@/views/docs/components/core/ui/form/BaseSelect.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseSwitch',
        name: 'docs-components-core-base-switch',
        component: () => import(
          /* webpackChunkName: "docs-core-base-switch" */
          '@/views/docs/components/core/ui/form/BaseSwitch.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseTextarea',
        name: 'docs-components-core-base-textarea',
        component: () => import(
          /* webpackChunkName: "docs-core-base-textarea" */
          '@/views/docs/components/core/ui/form/BaseTextarea.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseHtmlEditor',
        name: 'docs-components-core-base-html-editor',
        component: () => import(
          /* webpackChunkName: "docs-core-base-tinymce-editor" */
          '@/views/docs/components/core/ui/form/BaseHtmlEditor.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/SelectCountry',
        name: 'docs-components-core-select-country',
        component: () => import(
          /* webpackChunkName: "docs-core-select-country" */
          '@/views/docs/components/core/ui/form/select/SelectCountry.vue'
        ),
        meta: { disableScrollToTop: true },
      },
      {
        path: 'components/core/BaseVideoPlayer',
        name: 'docs-components-core-base-video-player',
        component: () => import(
          /* webpackChunkName: "docs-core-base-video-player" */
          '@/views/docs/components/core/ui/BaseVideoPlayer.vue'
          ),
        meta: { disableScrollToTop: true },
      },


    ],
  },
];
